import React, { FC }                            from 'react';
import { GenericNav, GenericNavComponentProps } from './GenericNav';
import { SystemAdminsOnly }                     from '../util/access/RoleAccessControl';
import { Icon }                                 from 'semantic-ui-react';
import { usePageNavs }                          from '../../../hooks';

const SystemAccountingNav: FC<Partial<GenericNavComponentProps>> = ( props ) => {
	
	let { generateSystemAccountingSectionNav } = usePageNavs();
	
	let navObjects = [
		{
			label:     <Icon name={ 'arrow circle left' } size={ 'large' } inverted fitted/>,
			path:      'ADMIN',
			isParent:  true,
			isDefault: false,
		},
		...generateSystemAccountingSectionNav()
	];
	
	return (
		<SystemAdminsOnly>
			<GenericNav withParent={ true } navObjects={ navObjects } { ...props }/>
		</SystemAdminsOnly>
	);
};

export { SystemAccountingNav }
